// extracted by mini-css-extract-plugin
export var attribution = "_9y-4";
export var authorName = "_9y-5";
export var quote = "_9y-3";
export var testimonial = "_9y-2";
export var trustedBy = "_9y-0";
export var trustedByLabel = "_9y-1";